import styled from 'styled-components';
import { brand, brandLight, grey10, white } from 'variables/colors';
import { fontWeightBold, montserrat } from 'variables/font';
import { borderRadius, boxShadow } from 'variables/general';

export const Page = styled.div`
  height: 100%;

  .rbc-month-view,
  .rbc-time-view {
    background-color: ${white};
  }

  .rbc-event-content {
    padding: 0.5em 0.3em;
    font-size: 11px;
  }

  .rbc-toolbar button:hover {
    background-color: ${grey10};
  }

  .rbc-toolbar-label {
    font-weight: ${fontWeightBold};
    font-size: 20px;
  }

  .rbc-row {
    .rbc-header {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      font-size: 16px;
      background-color: ${brandLight};
    }
  }

  .rbc-agenda-view {
    background-color: ${white};
  }

  .rbc-btn-group {
    button {
      width: 6.25em;
      font-size: 14px;
      font-family: ${montserrat};
      background-color: ${white};
      border: 0;
      border-radius: ${borderRadius};
      cursor: pointer;

      &:hover {
        font-weight: ${fontWeightBold};
        background-color: ${white};
      }
    }

    button:first-child:not(:last-child) {
      border-radius: ${borderRadius};
    }

    &:first-of-type {
      button {
        width: 5em;
        padding: 1em 0;
        border-radius: ${borderRadius};
        box-shadow: ${boxShadow};

        &:not(:last-of-type) {
          margin-right: 1em;
        }
      }
    }

    &:last-of-type {
      padding: 1em;
      background-color: ${white};
      border-radius: ${borderRadius};
      box-shadow: ${boxShadow};

      button {
        &:focus,
        &:active {
          background: 0;
          box-shadow: none;
        }
      }

      .rbc-active {
        padding: 8px auto;
        color: ${brand};
        font-weight: ${fontWeightBold};
        background-color: ${brandLight};
        border-radius: ${borderRadius};
        box-shadow: none;

        &:hover {
          color: ${brand};
          background-color: ${brandLight};
        }
      }
    }
  }

  .rbc-event {
    background-color: ${brand};
  }

  .rbc-date-cell {
    display: flex;
    flex-flow: row-reverse;
    align-items: center;
    height: 40px;
    padding-right: 15px;

    a {
      font-weight: ${fontWeightBold};
    }
  }
`;
